<template>
    <div class="warp">
        <div class="sidebar">
            <div class="contain">
                <div class="contain-top">{{subtitle}}</div>
                <div class="contain-min">
                    <ul>
                        <li v-for='item in contentList' :key= item.key>
							<router-link :to="{path:'/informationdetails', query: {id: item.id, cid: item.category_id, mainid: mainid, subid: subid}}">
                            <img :src='item.picture.path' alt="">
                            <div class="contain-right">
                                <div class="side-title">{{item.title}}</div>
                                <div class="content" id="contens">{{item.description}}</div>
                                    <div class="reading icon-container" style="bottom:-15px"> 
                                            <i class="iconfont icon-linedesign-14"><span class="read-num">{{item.view}}</span></i>
                                    </div>
                                    <div class="reltime" style="bottom:-15px">{{item.times}}</div>
                                </div>
							</router-link>
                        </li>
                    </ul>
                </div>  
            </div>
            <div class="side-left">
                <div class="top5">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABSklEQVRoQ+1awU7CQBCd2cXvsIZDa4hcSIyJ4WSwfIafoAlnLx4N8A1+AHcrZ7hgQkhQMZEg/yE7hhguBNJJu0aIr9d97eybeTs7s1umPX/Y1/y7QRQ7lqrme8bZTm3+OtRg0zDeCCSH4b2QNNIMLseZzVX8OXnQYNMwILDyECKQppUt45AQJJRROqvXICFICBLK6QFIKKcDdyoLPR6VTkm+ShpObM0gnr6Nd4pAEoRtEbnWECAyjfp80gQBn4sYEdBpbzPKRz+ACCACOZv6zBJKgqgl4m40ETCGby9n73fr2D9dAyBARIjA0glZSwlICBL6yWmQEPYB7MQZOzKkUaRRpFGU06hGUUqgpfRwU/9/q9FucHy2YDnRVKPWmedNP2okxagijlVH4wfW9i4+xtN1e0/F8FwWVNbMQ7jQr89eRt5OpzVGfwPzDUkm+k/7BI/fAAAAAElFTkSuQmCC" alt="">
                    <span>TOP5</span>
                </div>
                <div class="card" v-for='(item, index) in topList' :key= item.index>                                                       
                    <div class="card-top">
                        <a :href="'/informationdetails?id='+item.id+'&cid='+item.category_id+'&mainid='+mainid+'&subid='+subid"><img :src="item.picture.path" alt=""></a>
                        <div class="top-num">{{index + 1}}</div>
                        <div class="card-right">
                            <a :href="'/informationdetails?id='+item.id+'&cid='+item.category_id+'&mainid='+mainid+'&subid='+subid">{{item.title}}</a>
                        </div>                     
                    </div>
                    <!-- <div class="card-btm" v-html="item.content"></div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'iside',
    data (){
      return {}
    },
    props:{
			subtitle: {
				type: String,
				default: function() {
					return '综合资讯'
				}
			},
			mainid: {
				type: String,
			},
			subid: {
				type: String,
			},
			contentList:{
					type:Array,
					default:function(){
									return[{
									key:'1',
									picture:{path:'https://arc-quan-hangzhou.oss-cn-hangzhou.aliyuncs.com/aliresearch/2020-03-11/df54001960b443508090ccfba53c71b7/%7BBBA8755E-52BF-4A4F-977B-4A7F24C00313%7D_20200311154222.jpg'},
									title:'',
									description:'',
									times:'',
									view:'0'
							}]
					}
			},
			topList:{
					type:Array,
					default:function(){
							return[{
								picture:{path:'https://arc-quan-hangzhou.oss-cn-hangzhou.aliyuncs.com/aliresearch/2020-03-11/df54001960b443508090ccfba53c71b7/%7BBBA8755E-52BF-4A4F-977B-4A7F24C00313%7D_20200311154222.jpg'},
								title:'',
								content: '',
								// times:'2019-12-27 16:49:00'
							}]
					}
			}
    }
}
</script>

<style>     
.icon-linedesign-14{
    font-size: 14px !important;    
}
.read-num{
    font-size: 12px;
    margin-left: 5px;
}
.sidebar .contain-min .contain-right .reltime, .sidebar .contain-min .contain-right .reading{
    bottom: -35px;
}
</style>